module.exports = new __parcel__URL__("shadow-phrases-words.dce7d8ff.mp4").toString();